import { AutomationBand } from '../apis/mspAnalyticsApi';

export type CategorySortKey = 'label' | 'count' | AutomationBand;
export type CategorySort = { key: CategorySortKey; direction: 'asc' | 'desc' };
export type BandCounts = Record<string, Partial<Record<AutomationBand, number>>>;

type SortableRow = { key: string; label: string; count: number };

export const DEFAULT_CATEGORY_SORT: CategorySort = { key: 'count', direction: 'desc' };

/** Text reads naturally A→Z; numbers are most useful biggest-first. */
export function nextCategorySort(current: CategorySort, key: CategorySortKey): CategorySort {
  if (current.key === key) return { key, direction: current.direction === 'asc' ? 'desc' : 'asc' };
  return { key, direction: key === 'label' ? 'asc' : 'desc' };
}

function sortValue(row: SortableRow, bandCounts: BandCounts, key: CategorySortKey): number | string {
  if (key === 'label') return row.label;
  if (key === 'count') return row.count;
  return bandCounts[row.key]?.[key] || 0;
}

export function sortCategoryRows<T extends SortableRow>(rows: T[], bandCounts: BandCounts, sort: CategorySort): T[] {
  const sign = sort.direction === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const left = sortValue(a, bandCounts, sort.key);
    const right = sortValue(b, bandCounts, sort.key);
    const primary = typeof left === 'string' ? left.localeCompare(right as string) : left - (right as number);
    // Stable, predictable tie-break: bigger categories first, then alphabetical.
    return primary * sign || b.count - a.count || a.label.localeCompare(b.label);
  });
}
